import { Toaster, toast } from "react-hot-toast";

export function foodTypes(restaurent) {
  let foodTypesData = `\u2022`;
  const Yes = "Yes";

  if (restaurent.biryani === Yes) {
    foodTypesData = `${foodTypesData}Biryani\t\t\u2022`;
  }
  if (restaurent.breakFast === Yes) {
    foodTypesData = `${foodTypesData}BreakFast\t\t\u2022`;
  }
  if (restaurent.chinese === Yes) {
    foodTypesData = `${foodTypesData}Chinese\t\t\u2022`;
  }
  if (restaurent.desserts === Yes) {
    foodTypesData = `${foodTypesData}Desserts\t\t\u2022`;
  }
  if (restaurent.healthy === Yes) {
    foodTypesData = `${foodTypesData}Healthy\t\t\u2022`;
  }
  if (restaurent.indian === Yes) {
    foodTypesData = `${foodTypesData}Indian\t\t\u2022`;
  }
  if (restaurent.pizza === Yes) {
    foodTypesData = `${foodTypesData}Pizza\t\t\u2022`;
  }
  if (restaurent.shakes === Yes) {
    foodTypesData = `${foodTypesData}Shakes\t\t\u2022`;
  }
  if (restaurent.shawarma === Yes) {
    foodTypesData = `${foodTypesData}Shawarma\t\t\u2022`;
  }
  if (restaurent.snacks === Yes) {
    foodTypesData = `${foodTypesData}Snacks\t\t\u2022`;
  }

  const lastIndex = foodTypesData.lastIndexOf("\t\t\u2022");
  if (lastIndex !== -1) {
    foodTypesData = foodTypesData.substring(0, lastIndex);
  }

  return foodTypesData;
}

export function isRestaurentAvailable(rest) {
  const currentHour = new Date().getHours();
  console.log(currentHour);
  console.log(
    ` rest image is ${rest.dbID}  opening time ${parseFloat(rest.openingTime) <= currentHour
    } is ${parseFloat(rest.openingTime)}  and closing time  ${parseFloat(
      rest.timings
    )} is ${parseFloat(rest.timings) > currentHour} `
  );
  if (
    parseFloat(rest.openingTime) <= currentHour &&
    parseFloat(rest.timings) > currentHour
  ) {
    return true;
  } else if (
    rest.openingTime2 !== "" &&
    rest.closingTime2 !== "" &&
    parseFloat(rest.openingTime2) <= currentHour &&
    parseFloat(rest.closingTime2) > currentHour
  ) {
    return true;
  } else if (
    rest.openingTime3 !== "" &&
    rest.closingTime3 !== "" &&
    parseFloat(rest.openingTime3) <= currentHour &&
    parseFloat(rest.closingTime3) > currentHour
  ) {
    return true;
  }
  return false;
  // return true;
}

export function isRestCategoryAvailable(restCat) {
  const currentHour = new Date().getHours();
  console.log(
    restCat.timeFrom,
    restCat.timeTo,
    restCat.timeFrom2,
    restCat.timeTo2,
    restCat.timeFrom3,
    restCat.timeTo3
  );
  if (
    parseFloat(restCat.timeFrom) <= currentHour &&
    parseFloat(restCat.timeTo) > currentHour
  ) {
    return true;
  } else if (
    restCat.timeFrom2 !== "" &&
    restCat.timeTo2 !== "" &&
    parseFloat(restCat.timeFrom2) <= currentHour &&
    parseFloat(restCat.timeTo2) > currentHour
  ) {
    return true;
  } else if (
    restCat.timeFrom3 !== "" &&
    restCat.timeTo3 !== "" &&
    parseFloat(restCat.timeFrom3) <= currentHour &&
    parseFloat(restCat.timeTo3) > currentHour
  ) {
    return true;
  }
  return false;
  // return true;
}

export const getDateTime = (isISoNeeded) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

  if (isISoNeeded) {
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`; //2023-06-02T17:39:07.330Z
  } else {
    return `${year}-${month}-${day}`;
  }
};

const qrcode = require("qrcode");

export const generateQRCode = async (data) => {
  console.log("<----- initating generating qr code ---->");

  try {
    const text = data;
    const options = {
      type: "image/png",
      rendererOpts: {
        quality: 0.5,
      },
    };

    const qrCodeDataURL = await qrcode.toDataURL(text, options);
    const base64EncodedQRCode = qrCodeDataURL.replace(
      /^data:image\/png;base64,/,
      ""
    );
    console.log(
      `<---- encoded string ra mawa :  - ${base64EncodedQRCode} ---->`
    );
    return base64EncodedQRCode;

    // Promise {<fulfilled>: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQA…gJ9Wsr1iBAhlLWAeTCvwB6zd+9jmlJvYAAAAASUVORK5CYII='}

    // console.log(base64EncodedQRCode);
  } catch (error) {
    console.error("Error generating QR code:", error);
  }
};

export function calculateOriginalPrice(discountPercentage, discountedPrice) {
  let originalPrice = discountedPrice * (1 - discountPercentage / 100);
  return Math.floor(originalPrice);
}

export const successToast = (title, message) => {
  toast.success(
    <div>
      <h4
        style={{
          fontSize: "1.1rem",
          color: "rgb(47, 35, 35)",
          margin: "0.1rem 0 0.3rem 0",
        }}
      >
        {title}
      </h4>
      <span
        style={{
          fontSize: "0.9rem",
          fontWeight: "bold",
          color: "rgb(47, 35, 35)",
        }}
      >
        {message}
      </span>
    </div>,
    {
      duration: 5000,
      style: {
        background:
          "linear-gradient(135deg, rgb(35, 249, 53), rgb(125, 255, 44) )",
        borderRadius: "10px",
        boxShadow: "8px 8px 10px rgba(229, 203, 9, 0.2)",
      },
    }
  );
};

export const errorToast = (title, message) => {
  toast.error(
    <div>
      <h4
        style={{
          fontSize: "1.1rem",
          color: "rgb(47, 35, 35)",
          margin: "0.1rem 0 0.3rem 0",
        }}
      >
        {title}
      </h4>
      <span
        style={{
          fontSize: "0.9rem",
          fontWeight: "bold",
          color: "rgb(47, 35, 35)",
        }}
      >
        {message}
      </span>
    </div>,
    {
      duration: 5000,
      style: {
        background:
          "linear-gradient(135deg, rgb(249, 110, 35), rgba(252, 86, 86, 0.955)",
        borderRadius: "14px",
        boxShadow: "8px 8px 10px rgba(229, 203, 9, 0.2)",
      },
    }
  );
};

export const getDeviceType = () => {
  const userAgent =
    typeof window.navigator === "undefined" ? "" : navigator.userAgent;
  if (/Android/i.test(userAgent)) return "Android";
  if (/iPad|iPhone|iPod/i.test(userAgent)) return "iOS";
  return "unknown";
};

const deviceType = getDeviceType();
console.log(deviceType); // "Android", "iOS", or "unknown"
